var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":_vm.lineGen(_vm._points())}})
}
var staticRenderFns = []

export { render, staticRenderFns }